// extracted by mini-css-extract-plugin
export default {"container":"VerticalFilterPanel_container__breSQ"};